module.exports = __webpack_public_path__ + "img/iPhone-3x.bfba1e37.png";